import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Message} from "primeng/api";
import {IFlow} from "../../../../../data/interfaces/iflow.interface";
import {ApiFlowDataService} from "../../../../../data/services/api/flow/api-flow-data.service";
import * as CapacitorCore from "@capacitor/core";
import * as CapacitorBrowser from "@capacitor/browser";
import {
  faArrowUpRightFromSquare,
  faCheck,
  faCircleExclamation,
  faCircleInfo,
  faFileSignature,
  faRotateRight,
  faShieldHalved,
  faSignature,
  faTriangleExclamation
} from "@fortawesome/free-solid-svg-icons";
import {ESTADOS_LX} from "../../../../../shared/ui/liga-ui";

// Cómo terminó «Ya firmé» (validateUserSign): firmado, aún pendiente o error.
export type ResultadoFirma = '' | 'firmado' | 'pendiente' | 'error'

@Component({
  selector: 'app-sign-document',
  templateUrl: './sign-document.component.html',
  styleUrls: ['./sign-document.component.scss']
})
export class SignDocumentComponent implements OnInit{
  responseMessage: Message[] = []
  showMessage = false
  startButtonIsAvailable = false
  @Input() data!: IFlow
  @Input() pushingId: string = ''
  @Output() onEndProcess = new EventEmitter()
  currentUrl = ''
  startedProcess = false

  // ---- Solo pantalla (no cambian lo que se manda al API) ----
  cargando = false
  // getUrl no pudo preparar el documento.
  errorCarga = false
  // El documento ya estaba firmado al entrar.
  yaFirmado = false
  // Entre «Firmar mi contrato» y la pantalla de espera (2 s).
  abriendo = false
  // El navegador no dejó abrir la ventana de la firma.
  ventanaBloqueada = false
  // La revisión cada 5 s ya vio el documento firmado.
  firmaDetectada = false
  // «Ya firmé»: esperando la confirmación.
  confirmando = false
  resultado: ResultadoFirma = ''
  anuncio = ''

  readonly estados = ESTADOS_LX
  private finEmitido = false
  readonly iconos = {
    contrato: faFileSignature,
    firmar: faSignature,
    abrir: faArrowUpRightFromSquare,
    listo: faCheck,
    error: faCircleExclamation,
    aviso: faTriangleExclamation,
    info: faCircleInfo,
    reintentar: faRotateRight,
    seguro: faShieldHalved
  }

  constructor(
    private flowDataService: ApiFlowDataService
  ) {
  }

  async ngOnInit() {
    this.getUrl()
  }

  getUrl() {
    this.cargando = true
    this.errorCarga = false
    this.responseMessage = []
    this.flowDataService.getWeetrustDocument({idDocument: this.data.id, idStage: this.data.userDocumentId, pushingId: this.pushingId}).subscribe(r => {
      this.cargando = false
      if (!r.error) {
        if (r.data.status === 'COMPLETED') {
          this.yaFirmado = true
          this.terminar()
        }
        this.data.userDocumentId = r.data.stageId
        // Sin liga de firma no hay nada que abrir (antes esto tronaba y el botón se quedaba apagado).
        this.currentUrl = r.data.weetrustDocument?.responseData?.signatory?.[0]?.signing?.url ?? ''
        this.startButtonIsAvailable = this.currentUrl !== ''
      } else {
        this.errorCarga = true
        this.responseMessage = [
          {
            summary: r.msg,
            severity: r.error ?  'error': 'success',
            closable: false,
          }
        ]
      }
    })
  }

  closeWindows(w: Window, url: any) {
    this.flowDataService.getWeetrustDocument({idDocument: this.data.id, idStage: this.data.userDocumentId, pushingId: this.pushingId}).subscribe(r => {

      if (!r.error && r.data.status === 'COMPLETED') {
        w.close()
        clearInterval(url)
        this.firmaDetectada = true
        this.anuncio = 'Detectamos tu firma. Toca «Ya firmé» para continuar.'
      }
    })
  }

  async openIneValidationUrl(url: string) {
    if (CapacitorCore.Capacitor.getPlatform() === 'web') {
      const incodeWindow = open(
        url,
        'user-validation',
        'width=550,height=700,status=0,toolbar=0'
      );
      if (incodeWindow) {
        const detectsUrl = setInterval( (a  = this) => {
          a.closeWindows(incodeWindow, detectsUrl)
        }, 5000);
      } else {
        this.ventanaBloqueada = true
      }

    } else {
      await CapacitorBrowser.Browser.open({url})
      /*await CapacitorBrowser.Browser.close().then(r => {
        console.log("url closed")
      })*/
    }
  }

  async start() {
    if (this.abriendo || this.confirmando) return
    this.abriendo = true
    this.ventanaBloqueada = false
    this.resultado = ''
    try {
      await this.openIneValidationUrl(this.currentUrl)
    } catch (e) {
      // Igual que antes (no pasa a la espera), pero el botón no se queda en «Abriendo…».
      this.abriendo = false
      throw e
    }
    setTimeout(( ) => {
      this.startedProcess = true
      this.abriendo = false
    }, 2000)

  }
  validateUserSign() {
    if (this.confirmando) return
    this.confirmando = true
    this.resultado = ''
    this.responseMessage = []
    this.anuncio = 'Estamos confirmando tu firma…'
    setTimeout(() => {
      this.flowDataService.getWeetrustDocument({idDocument: this.data.id, idStage: this.data.userDocumentId, pushingId: this.pushingId}).subscribe(r => {
        this.confirmando = false
        this.responseMessage = [
          {
            summary: r.msg,
            severity: r.error ?  'error': 'success',
            closable: false,
          }
        ]
        this.resultado = r.error ? 'error' : (r.data?.status === 'COMPLETED' ? 'firmado' : 'pendiente')
        this.anuncio = this.resultado === 'firmado' ? '¡Listo! Firmaste tu contrato' : String(r.msg ?? '')
        if (!r.error) {
          setTimeout(() => this.terminar(), 2000)
        }
      })
    }, 5000)

  }

  // Encabezado y nota del botón en la espera, según lo que está pasando.
  get textosEspera(): {titulo: string; subtitulo: string; nota: string} {
    if (this.confirmando) return {titulo: 'Estamos confirmando tu firma', subtitulo: 'Revisamos que tu contrato haya quedado firmado.', nota: 'No cierres esta pantalla.'}
    if (this.resultado === 'error') return {titulo: 'Termina de firmar', subtitulo: 'Revisa que hayas terminado en la ventana de firma y vuelve a tocar «Ya firmé».', nota: 'Tócalo cuando hayas terminado de firmar.'}
    if (this.resultado === 'pendiente') return {titulo: 'Te regresamos a tus pasos', subtitulo: 'Ahí verás cuando tu firma quede lista.', nota: 'Un momento…'}
    return {titulo: 'Termina de firmar', subtitulo: 'Firma en la ventana que se abrió. Al terminar, regresa aquí y toca «Ya firmé».', nota: 'Tócalo cuando hayas terminado de firmar.'}
  }

  get mensaje(): string {
    return String(this.responseMessage[0]?.summary ?? '')
  }

  // Etapas de la pantalla: 0 = revisa, 1 = firma, 2 = confirma.
  // Firmado (o ya estaba): las tres partes en verde.
  get firmado(): boolean {
    return this.yaFirmado || this.resultado === 'firmado'
  }

  // Un solo onEndProcess(true): el regreso automático y «Continuar» de la
  // celebración pasan por aquí (mismo evento, mismos tiempos de antes).
  terminar() {
    if (this.finEmitido) return
    this.finEmitido = true
    this.onEndProcess.emit(true)
  }

  get etapa(): number {
    if (!this.startedProcess) return 0
    return this.confirmando || this.resultado ? 2 : 1
  }

  claseEtapa(i: number): string {
    if (this.firmado) return 'is-listo'
    if (i < this.etapa) return 'is-listo'
    return i === this.etapa ? 'is-actual' : ''
  }
}
